// extracted by mini-css-extract-plugin
export default {"column":"Filter_column__Ft+dk","boxCSV":"Filter_boxCSV__TMq3r"};